import { RouteObject } from "react-router-dom";
import { PrincipalReferenceSurveyLoader } from "./loader";
import { lazy } from "react";
export const PrincipalReferenceSurvey = lazy(() => import('./index').then(m => ({ default: m.default})))

export const principalReferenceSurveyRoute: RouteObject = {
    path: 'referencePrincipal/:requestId',
    loader: PrincipalReferenceSurveyLoader,
    element: <PrincipalReferenceSurvey/>
}